import { CLIENTS } from 'views/clients/clientsList';

export const clients = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Clients - Boldare',
  url: 'https://www.boldare.com/clients/',
  description:
    "Our clients work with us to create and launch custom software development projects to positively impact their customers' lives. Find out how you can too.",
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@id': 'https://www.boldare.com/',
          name: 'Home',
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@id': 'https://www.boldare.com/clients/',
          name: 'Clients',
        },
      },
    ],
  },
  mainEntity: {
    '@type': 'ItemList',
    name: 'Clients of Boldare',
    itemListElement: CLIENTS.map((client) => ({
      '@type': 'Organization',
      name: client?.name,
      url: client?.url,
    })),
  },
};
